export class Quota {
    public userId: string;
    public companyId: string;
    public limit: number;
    public apiKey: string;

    constructor();
    constructor(json: any);
    constructor(json?: any) {
        if (json) {
            this.userId = json.userId;
            this.companyId = json.companyId;
            this.limit = json.limit;
            this.apiKey = json.apiKey;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/models/quota.ts